import React from 'react'
import PropTypes from 'prop-types'

const Grid = props => {
  const { fluid, ...baseProps } = props
  const containerClass = props.fluid ? 'container-fluid' : 'container'
  const classNames = [props.className, containerClass].join(' ').trim()

  return <div {...baseProps} className={classNames} />
}

Grid.propTypes = {
  fluid: PropTypes.bool,
  className: PropTypes.string
}

export { Grid }



// WEBPACK FOOTER //
// ./src/components/Grid/Grid.js